import { Lead } from "../actions/lead";
import { postLead, deleteLead } from "../../api/index";

export const attemptSubmitLead = (newLead: Lead, recaptchaToken: string) => () => postLead(newLead, recaptchaToken);

export const attemptDeleteLead = (leadId: string) => () => deleteLead(leadId);

// export const attemptExportLeads = (leadIds: Array<string>) => () => getLeadsExport(leadIds);